export enum OiamEvents {
    OIAM_LOADED_EVENT = 'oiamLoadedEvent',
    OIAM_READY_FOR_LOGIN_EVENT = 'oiamReadyForLoginEvent',
    OIAM_SET_CONFIG_EVENT = 'oiamSetConfigEvent',
    OIAM_LOGIN_EVENT = 'oiamLoginEvent',
    OIAM_LOGOUT_EVENT = 'oiamLogoutEvent',
    OIAM_TOKEN_EVENT = 'oiamTokenEvent',
    OIAM_CUSTOMSTATE = 'oiamCustomStateEvent'

}
